import React, { useCallback, useRef } from 'react';
import { Formbot, styled, Row, Column, Input, PhoneInput, Box } from '@goodrx/matisse';
import * as yup from 'yup';
import { debounce } from 'lodash';
import { OnboardingField, OnboardingFieldProps } from './OnboardingField';

export const CardTitle = styled.h3`
  font-size: 18px;
  margin: 1rem 0 0;
`;

export const CardSubtitle = styled.p`
  margin: 0 0 1rem;
  color: ${(p: any) => p.theme.colors.greyDarkest};
  font-size: 14px;
`;

const Profile: React.FunctionComponent<OnboardingFieldProps> = ({ values: profile, onChange }) => {
  const profileFormRef: any = useRef();

  const handleProfileChange = useCallback(
    (_field: any, _value: any, values: any) => {
      onChange({
        values,
        validate: () => {
          if (!profileFormRef.current) {
            return { valid: false };
          }

          return {
            valid: profileFormRef.current.isValid,
            errorMessage: 'Invalid profile.',
          };
        },
      });
    },
    [onChange]
  );

  return (
    <>
      <Formbot
        ref={profileFormRef}
        validationSchema={{
          firstName: yup.string().required('Please enter your first name.'),
          lastName: yup.string().required('Please enter your last name.'),
          phone: yup.string().test({
            name: 'phone',
            message: 'Must be a valid phone number',
            test: (val) => {
              const raw = (val || '').replace(/[^0-9]/g, '');
              return /^\d{10}$/.test(raw);
            },
          }),
        }}
        initialValues={profile}
        onChange={debounce(handleProfileChange, 25)}>
        <Row mb={3}>
          <Column xs={6}>
            <Input name="firstName" floating label="First Name" placeholder="First Name" />
          </Column>
          <Column xs={6}>
            <Input name="lastName" floating label="Last Name" placeholder="Last Name" />
          </Column>
        </Row>
        <Box mb={3}>
          <PhoneInput name="phone" floating label="Phone Number" placeholder="Phone Number" />
        </Box>
      </Formbot>
    </>
  );
};

const ProfileWrapper: React.FunctionComponent = () => {
  return (
    <OnboardingField errorFieldName="profile" fields={['firstName', 'lastName', 'phone']}>
      {(props) => <Profile {...props} />}
    </OnboardingField>
  );
};

export { ProfileWrapper as Profile };
